export default "__VITE_ASSET__DhQhyBae__"